/**
 * Script: gift-card-product.js
 * Purpose: Interactive behaviors for the Gift Card luxury template:
 *          - Denomination grid selection and variant sync
 *          - Custom recipient toggle expansion with full Shopify recipient properties
 *          - Description accordion interactions
 */

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.gift-card-page');
  if (!container) return;

  const form = container.querySelector('form[action*="/cart/add"]');
  const variantInput = form ? form.querySelector('input[name="id"]') : null;
  const amountButtons = container.querySelectorAll('.gift-card-page__amount-btn[data-variant-id]');
  const recipientToggle = container.querySelector('#GiftCardRecipient-Toggle');
  const recipientFields = container.querySelector('.gift-card-recipient-fields');
  const offsetInput = container.querySelector('#GiftCardRecipient-Offset');
  const dateInput = container.querySelector('#GiftCardRecipient-Date');
  const accordionHeaders = container.querySelectorAll('.gift-card-page__accordion-header');

  // 1. Amount / Variant Selection
  amountButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      amountButtons.forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      if (variantInput) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update URL without reloading page
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', currentUrl.toString());
    });
  });

  // 2. "Send as a Gift?" Toggle Switch & Native Recipient Properties
  if (recipientToggle && recipientFields) {
    const inputs = recipientFields.querySelectorAll('input, textarea');

    // Populate timezone offset
    if (offsetInput) {
      offsetInput.value = new Date().getTimezoneOffset().toString();
    }

    // Enable the toggle switch so the user can interact
    recipientToggle.disabled = false;

    const updateRecipientState = () => {
      const isChecked = recipientToggle.checked;
      if (isChecked) {
        recipientFields.classList.add('is-visible');
        inputs.forEach((input) => {
          input.disabled = false;
        });
        if (offsetInput) offsetInput.disabled = false;
      } else {
        recipientFields.classList.remove('is-visible');
        inputs.forEach((input) => {
          input.disabled = true;
          input.value = '';
        });
        if (offsetInput) offsetInput.disabled = true;
      }
    };

    recipientToggle.addEventListener('change', updateRecipientState);
    updateRecipientState(); // Initialize on load

    // When form is submitted, if send-on date is blank, disable date so Shopify sends immediately
    if (form) {
      form.addEventListener('submit', () => {
        if (recipientToggle.checked && dateInput && !dateInput.value) {
          dateInput.disabled = true;
        }
      });
    }
  }

  // 3. Accordion Toggle
  accordionHeaders.forEach((header) => {
    header.addEventListener('click', () => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const body = header.nextElementSibling;

      if (isExpanded) {
        header.setAttribute('aria-expanded', 'false');
        if (body) body.classList.remove('is-open');
      } else {
        header.setAttribute('aria-expanded', 'true');
        if (body) body.classList.add('is-open');
      }
    });
  });
});
